(function() {
  'use strict';

  angular.module('forgotUser', [
    'ngResource',
    'dnErrorDisplay',
    'common',
    'ui.bootstrap'
  ]);
})();
